import { useSwingAnalysis } from '@queries';

export const useAnalysisById = (uuid: string | null | undefined) => {
    const { data: analysis } = useSwingAnalysis(uuid ?? undefined);

    return analysis?.fullAnalysis ?? analysis?.quickAnalysis;
};
